(function() {
  const rpm = document.getElementById('calc-rpm');
  const micros = document.getElementById('calc-micros');
  const timing = document.getElementById('calc-timing');
  const degOut = document.getElementById('calc-degOut');
  const eoiOut = document.getElementById('calc-eoiOut');

  function parseNum(el) {
    const v = parseFloat(el.value);
    return Number.isFinite(v) ? v : 0;
  }

  function fmt(n) {
    return Number.isFinite(n) ? n.toFixed(3) : '—';
  }

  function compute() {
    const r = parseNum(rpm);
    const us = parseNum(micros);
    const btdc = parseNum(timing);

    // Excel: C8 = C3 * C4 / 166666
    const degrees = r * us / 166666;
    // Excel: C9 = C5 - C8
    const eoi = btdc - degrees;

    degOut.textContent = fmt(degrees);
    eoiOut.textContent = fmt(eoi);
  }

  for (const el of [rpm, micros, timing]) {
    el.addEventListener('input', compute);
    el.addEventListener('change', compute);
  }

  compute();
})();